import React, { useState, useEffect } from "react";
import { developAxios } from "../axios.config";

const AddCourses = () => {
	const [course, setCourse] = useState([]);
	const [email, setEmail] = useState();
	const [value, setValue] = useState();
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/getAllCourse")
			.then(({ data }) => {
				console.log(data);
				setCourse(data.courses);
			})
			.catch((e) => console.log(e));
	}, []);

	const handleClick = () => {
		developAxios(localStorage.getItem("token"))
			.post("/addCourseToAccessList", {
				courseId: value,
				userEmail: email,
			})
			.then(({ data }) => {
				console.log(data);
				alert("Successfully created Course");
			})
			.catch((e) => {
				console.log(e);
				alert("Something went Wrong Please check the creds");
			});
	};

	return (
		<div className="flex flex-column justify-center items-center">
			<div className="my-5	">
				<h2>Select Course</h2>
			</div>
			<div className="w-2/5	">
				<select
					id="mySelect"
					onChange={(e) => setValue(e.target.value)}
				>
					<option value="">Select an option</option>
					{course.map((option) => (
						<option key={option._id} value={option._id}>
							{option.name}
						</option>
					))}
				</select>
			</div>
			<br />
			<br />

			<div className="w-2/5	">
				<label className="block">
					<span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
						Email
					</span>
					<input
						type="email"
						name="email"
						className=" mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
						placeholder="you@example.com"
						onChange={(e) => setEmail(e.target.value)}
					/>
				</label>
			</div>
			<div className="my-5	">
				<button
					onClick={handleClick}
					className="rounded-none bg-teal-900 px-2 py-2 text-white	cursor-pointer "
				>
					Add Course
				</button>
			</div>
		</div>
	);
};

export default AddCourses;
